import React, { useEffect, useRef, useState } from "react";
import PricingSection from "../components/PricingSection";
import { supabase } from "../supabaseClient";
import { trackGoal } from "../utils/datafast";
import "./PublicSite.css";

export default function PlansPage() {
  const [subscriptionTier, setSubscriptionTier] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const plansRootRef = useRef(null);

  useEffect(() => {
    const loadPlan = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      const userId = sessionData?.session?.user?.id;
      if (!userId) return;
      const { data: profileRow } = await supabase
        .from("profiles")
        .select("subscription_tier,subscription_status")
        .eq("id", userId)
        .maybeSingle();
      if (profileRow) {
        setSubscriptionTier(profileRow.subscription_tier || "free");
        setSubscriptionStatus(profileRow.subscription_status || "inactive");
      }
    };
    loadPlan();
  }, []);

  useEffect(() => {
    trackGoal("view_pricing");
  }, []);

  useEffect(() => {
    const rootNode = plansRootRef.current;
    if (!rootNode) return undefined;
    const revealNodes = rootNode.querySelectorAll("[data-reveal]");
    if (!revealNodes.length) return undefined;

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    revealNodes.forEach((node) => node.classList.remove("is-visible"));

    if (prefersReducedMotion) {
      revealNodes.forEach((node) => node.classList.add("is-visible"));
      return undefined;
    }

    const rafId = window.requestAnimationFrame(() => {
      revealNodes.forEach((node) => node.classList.add("is-visible"));
    });
    return () => window.cancelAnimationFrame(rafId);
  }, []);

  return (
    <div ref={plansRootRef} className="plans-page public-shell landing clearbadge-public pricing-page">
      <h1 className="sr-only" data-page-heading="true">Plans</h1>
      <div className="landing-main pricing-main">
        <PricingSection
          id="plans"
          className="pricing-section-core"
          currentTier={subscriptionTier}
          currentStatus={subscriptionStatus}
          header={(
            <div className="pricing-page-hero-head">
              <h1 data-reveal style={{ "--reveal-delay": "120ms" }}>Simple, Transparent Pricing</h1>
              <p data-reveal style={{ "--reveal-delay": "240ms" }}>Start free. Upgrade anytime.</p>
            </div>
          )}
        />
      </div>
    </div>
  );
}

